import BasicRender from "./BasicRender";

/**
 *
 * Component renders a list of editable templates of type PositionPlan
 */
const PlanPositioningRender = ({
  planPositioningTemplate,
  onRemove,
  isEditable,
}) => {
  return (
    <BasicRender
      datasetTemplate={planPositioningTemplate}
      onRemove={onRemove}
      isEditable={isEditable}
    />
  );
};

export default PlanPositioningRender;
